module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/customer-search-select/customer-search-select.component.scss
// module id = ./src/app/modules/common-module/components/customer-search-select/customer-search-select.component.scss
// module chunks = 9